module.exports = __webpack_public_path__ + "statics/img/cate3-6@2x.d87deb34.png";